import styled from 'styled-components';
import MathContent from '../../math-content';

export const PublicTitle = styled(MathContent)`
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.2px;
    line-height: 20.4px;
`;

export const Question = styled(MathContent)`
    line-height: 2.25rem;
    font-size: 16px;
    overflow-wrap: break-word;

    img {
        margin: calc(var(--space-unit) / 2);
        vertical-align: middle;
    }

    ol,
    ul {
        margin: 0px;
        line-height: 1.5rem;
    }

    ul {
        list-style-position: outside;
        padding-left: 24px;
    }

    ol {
        list-style-position: inside;
        padding-left: 4px;
    }

    p:first-of-type {
        margin: 0;
    }
`;

export const Attachments = styled.div`
    display: ${(props) => !props.show && 'none'};
`;
